import React from 'react'
import { Group } from '@mantine/core'
import IonIcon from '@reacticons/ionicons'
import ModalCloseButton from './modal-close-button'

type ReactText = string | number
type ReactChild = React.ReactElement | ReactText
type ReactNode = ReactChild | React.ReactPortal | boolean | null | undefined

type ModalContentWrapperProps = {
    title?: string
    subTitle?: string
    withCloseIcon?: boolean
    closeModal?: () => void
    withMaximizeButton?: boolean
    onMaximize?: () => void
    isMaximized?: boolean
    banner?: ReactNode
    children: ReactNode
}

function ModalContentWrapper({ title, subTitle, withCloseIcon, closeModal, withMaximizeButton, onMaximize, isMaximized, banner, children }: ModalContentWrapperProps) {
    return (
        <div className="modal-content-wrapper">
            {withCloseIcon ?
                (
                    <Group w='100%' position='apart'>
                        <Group style={{ flex: 1 }} position="apart">
                            <h4 className="modal-content-wrapper-title">{title}</h4>
                            {banner}
                            {subTitle && <h4 className="modal-content-wrapper-subtitle">{subTitle}</h4>}
                        </Group>
                        <Group spacing='xs'>
                            {withMaximizeButton && onMaximize && (
                                <button
                                    onClick={onMaximize}
                                    className="modal-maximize-button"
                                    title={isMaximized ? "Restore window" : "Maximize window"}
                                >
                                    <IonIcon
                                        name={isMaximized ? "contract-outline" : "expand-outline"}
                                        style={{
                                            width: '20px',
                                            height: '20px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            paddingTop: '2px'
                                        }}
                                    />
                                </button>
                            )}
                            <ModalCloseButton closeModal={closeModal} />
                        </Group>
                    </Group>
                ) :
                (
                    <h4 className="modal-content-wrapper-title">{title}</h4>
                )}
            <div className="form-wrapper-body">{children}</div>
        </div>
    )
}

export default ModalContentWrapper